import { Routes } from '@angular/router';
import { DASHBOARD_ROUTES } from './dashboard/dashboard.routes';
import { SITE_ROUTES } from './site/site.routes';
import { AUTH_ROUTES } from './auth/auth.routes';
import { authGuard } from './core/guard/auth.guard';
import { adminGuard } from './core/guard/admin.guard';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';
import { loginGuard } from './core/guard/login.guard';

export const routes: Routes = [
  // ✅ Default redirect to /landing or /home as you prefer
  // { path: '', redirectTo: '/home', pathMatch: 'full' },

  // 🏠 Public Landing Page
  {
    path: '',
    canActivate: [loginGuard],
    loadComponent: () =>
      import('./landing/landing/landing.component').then(
        m => m.LandingComponent
      ),
  },
  // 👤 Site / Company Area (Authenticated Users)
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () => import('./site/site.routes').then(m => m.SITE_ROUTES),
  },

  // 🔐 Auth Routes (Login, Register, etc.)
  {
    path: 'auth',
    canActivate: [loginGuard],
    loadChildren: () => import('./auth/auth.routes').then(m => m.AUTH_ROUTES),
  },

  // 🧭 Admin Dashboard (Admin Only)
  // {
  //   path: 'dashboard',
  //   // canActivate: [adminGuard],
  //   loadChildren: () =>
  //     import('./dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
  // },

  // 📝 Blog Pages
  {
    path: 'blog',
    loadComponent: () =>
      import('./landing/blog/blog.component').then(m => m.BlogComponent),
  },
  {
    path: 'blog/:slug',
    loadComponent: () =>
      import('./landing/blog-detail/blog-detail.component').then(
        m => m.BlogDetailComponent
      ),
  },

  // 📄 Legal Pages
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./landing/privacy-policy/privacy-policy.component').then(
        m => m.PrivacyPolicyComponent
      ),
  },
  {
    path: 'terms-conditions',
    loadComponent: () =>
      import('./landing/terms-conditions/terms-conditions.component').then(
        m => m.TermsConditionsComponent
      ),
  },

  // 🎫 Support Ticket Page
  {
    path: 'support-ticket',
    loadComponent: () =>
      import('./landing/pages/support-ticket/support-ticket.component').then(
        m => m.SupportTicketPageComponent
      ),
  },

  // ❌ Catch-all Not Found
  { path: '**', component: PageNotFoundComponent },
];

// export const routes: Routes = [
//   {
//     path: '',
//     redirectTo: '/home',
//     pathMatch: 'full',
//   },
//   {
//     path: '',
//     canActivate: [authGuard],
//     loadChildren: () => import('./site/site.routes').then(m => m.SITE_ROUTES),
//   },
//   {
//     path: 'landing',
//     loadComponent: () =>
//       import('./landing/ajazat-landing/ajazat-landing.component').then(
//         m => m.AjazatLandingComponent
//       ),
//   },
//   {
//     path: 'auth',
//     canActivate: [loginGuard],
//     loadChildren: () => import('./auth/auth.routes').then(m => m.AUTH_ROUTES),
//   },
//   {
//     path: 'dashboard',
//     canActivate: [adminGuard],
//     loadChildren: () =>
//       import('./dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
//   },
//   { path: '**', component: PageNotFoundComponent },
// ];

// ...SITE_ROUTES,
// ...AUTH_ROUTES,
// ...DASHBOARD_ROUTES,
